// extracted by mini-css-extract-plugin
export default {"section":"yByWm","side--vAuto":"auzZR","side--top":"brkwa","side--bottom":"f4Nk0","side--vMiddle":"oAj9L"};